// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text } from 'pixi.js';
import { ButtonLargeLayout } from '../common/buttons/ButtonLargeLayout';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'a671e798-2586-47be-a876-d89b14bc868e',
      type: 'Container',
      name: 'popup',
      className: '',
      x: 390,
      y: 640,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '1acb71d2-8d78-48f7-84fb-7dbbb7d52d18',
      type: 'Container',
      name: 'contentContainer',
      className: '',
      x: 0,
      y: -21,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'a671e798-2586-47be-a876-d89b14bc868e'
    },
    {
      id: '3f4d5845-e716-4a0a-a18d-df8aa4e7e42b',
      type: 'Container',
      name: 'chestSlot',
      className: '',
      x: 0,
      y: 140,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1acb71d2-8d78-48f7-84fb-7dbbb7d52d18'
    },
    {
      id: 'ac4b023a-4ad4-407e-a1c6-355d812a1490',
      type: 'Container',
      name: 'collectButtonContainer',
      className: '',
      x: 0,
      y: 420,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '1acb71d2-8d78-48f7-84fb-7dbbb7d52d18'
    },
    {
      id: '661724ad-9a4d-48e6-93e2-387fc479e8d4',
      type: 'Layout',
      name: 'collectButton',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'ac4b023a-4ad4-407e-a1c6-355d812a1490',
      data: {
        color: 'green'
      },
      stateByName: {
        'main-menu': {
          visible: false
        },
        'main-menu-max-lives': {
          visible: true
        }
      }
    },
    {
      id: '260e4999-c8fd-481f-b407-a48e1bd399ab',
      type: 'Text',
      name: 'collectText',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Collect',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 1,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x00700c',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '661724ad-9a4d-48e6-93e2-387fc479e8d4'
    }
  ],
  x: 0,
  y: 0,
  width: 780,
  height: 1280,
  version: '1.0.0',
  handleResize: false
} as const;

export class BasicRewardChestPopupLayout {
  static raw = raw;
  root!: Container;
  popup!: Container;
  contentContainer!: Container;
  chestSlot!: Container;
  collectButtonContainer!: Container;
  collectButton!: ButtonLargeLayout & { data: typeof raw['list'][5]['data'] };
  collectText!: Text;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
